import defaultApp from './defaultApp.js';

import Stars from './components/Stars.vue';

const amazonApp = {
    ...defaultApp,
    components: {
        ...defaultApp.components,
        Stars
    },
    data() {
        return {
            ...defaultApp.data(),
            isActive: false,
            dataReviewslabel: 'Reviews'
        };
    },
    computed: {
        ...defaultApp.computed,
        dataSet() {
            return this.data && this.data.url && this.data.reviewCount && this.data.rating;
        },
        starsNumber() {
            if (!this.data.rating) return 0;
            return Number(this.data.rating);
        },
        starsDutch() {
            return this.starsNumber.toString().replace('.', ',');
        }

    },
    methods: {
        ...defaultApp.methods,
        setData(response, replace = false) {
            if (!response || response.status != 200) return;
            this.data = response.data;
        },
        togglePopup(open = true) {
            this.isActive = open;
        }
    },
    mounted() {
        this.init();
        if (this.$el.dataset.reviewslabel) this.dataReviewslabel = this.$el.dataset.reviewslabel;
    },
    updated() {
        if (this.$refs.popup) {
            document.addEventListener('click', (event) => {
                let isClickInside = false;

                if (this.$el.contains(event.target)) {
                    isClickInside = true;
                }

                if (!isClickInside) {
                    this.togglePopup(open = false);
                }
            });
        }
    }
};

export default amazonApp;
